/* Maison Safara Aroma theme scripts */
(function () {
  'use strict';

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* Announcement rotator */
  function initRotators(root) {
    $$('[data-rotator]', root).forEach(function (el) {
      var items = $$('.announcement__item', el);
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(el.dataset.interval, 10) || 5000);
    });
  }

  /* Hero slideshow */
  function initSlideshows(root) {
    $$('[data-slideshow]', root).forEach(function (el) {
      var slides = $$('.hero__slide', el);
      var dots = $$('.hero__dot', el);
      if (slides.length < 2) return;
      var index = 0, timer;
      function go(n) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }
      function start() {
        if (el.dataset.autoplay !== 'true') return;
        clearInterval(timer);
        timer = setInterval(function () { go(index + 1); }, parseInt(el.dataset.interval, 10) || 6000);
      }
      var prev = el.querySelector('[data-slide-prev]');
      var next = el.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.slideTo, 10)); start(); }); });
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', start);
      // Show the block selected in the theme editor
      el.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1) { clearInterval(timer); go(i); }
      });
      start();
    });
  }

  /* Horizontal scrollers with arrows */
  function initScrollers(root) {
    $$('[data-scroller]', root).forEach(function (track) {
      var section = track.closest('section');
      var step = function () { return track.clientWidth * 0.8; };
      var prev = section && section.querySelector('[data-scroll-prev]');
      var next = section && section.querySelector('[data-scroll-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* Drawers (mobile menu, filters) */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    if (d.id !== 'FacetDrawer') d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.theme.openDrawer = openDrawer;
  window.theme.closeDrawer = closeDrawer;
  window.theme.formatMoney = formatMoney;
  window.theme.toast = function (m) { toast(m); };
  window.theme.updateCartCount = function () { updateCartCount(); };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { var d = closer.closest('[data-drawer]'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-drawer].is-open').forEach(closeDrawer);
  });

  /* Mega menu keyboard support */
  function initMegaMenu() {
    $$('.main-nav__item.has-mega').forEach(function (item) {
      var link = item.querySelector('.main-nav__link');
      item.addEventListener('focusin', function () { item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }
      });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); });
    });
  }

  /* Quantity buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input');
    var min = parseInt(input.min, 10) || 0;
    var val = parseInt(input.value, 10) || 0;
    input.value = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page auto-update */
  var cartTimer;
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]')) {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var form = e.target.form;
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = 'update'; input.value = '1';
        form.appendChild(input);
        form.submit();
      }, 500);
    }
  });

  /* Toast */
  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span></span><a href="' + window.theme.routes.cart_url + '">View bag</a>';
    el.firstChild.textContent = message;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function updateCartCount() {
    fetch(window.theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (c) {
          c.textContent = cart.item_count;
          c.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Error'); return; }
        var gift = form.id ? document.querySelector('[data-gift-toggle][form="' + form.id + '"]:checked') : null;
        var wrapId = gift && gift.getAttribute('data-gift-wrap');
        var extra = Promise.resolve();
        if (wrapId) {
          /* Gift wrap is a separate £ line, tied to the perfume it wraps */
          var msg = document.querySelector('[data-gift-message][form="' + form.id + '"]');
          var props = { 'For': res.data.product_title || res.data.title || '' };
          if (msg && msg.value) props['Gift message'] = msg.value;
          extra = fetch(window.theme.routes.cart_add_url + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(wrapId, 10), quantity: 1, properties: props }] })
          }).catch(function () {});
        }
        var applyCode = form.getAttribute('data-apply-code');
        if (applyCode) extra = extra.then(function () { return fetch('/discount/' + encodeURIComponent(applyCode) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {}); });
        return extra.then(function () {
          updateCartCount();
          if (window.CartDrawer) { window.CartDrawer.open(); } else { toast(window.theme.strings.added); }
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Product page: gallery and variants */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (el) {
      var slides = $$('.product__slide', el);
      var thumbs = $$('[data-thumb]', el);

      function showMedia(id) {
        if (!id) return;
        slides.forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

      var json = el.querySelector('[data-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = el.querySelector('[data-variant-id]');
      var addBtn = el.querySelector('[data-add-button]');
      var priceEl = el.querySelector('.product__price [data-price]');

      el.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var selected = $$('[data-option-index]:checked', el).map(function (i) { return i.value; });
        $$('[data-option-label]', el).forEach(function (l, i) { l.textContent = selected[i]; });
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.theme.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        }
        if (priceEl) {
          var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price > variant.price) html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          priceEl.innerHTML = html;
          priceEl.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        el.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant, price: formatMoney(variant.price) } }));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* Product recommendations */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.children.length && el.querySelector('.product-grid')) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var fresh = html.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* Filters: submit on change */
  function initFacets(root) {
    $$('[data-facets-form]', root).forEach(function (form) {
      var t;
      form.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var params = new URLSearchParams(new FormData(form));
          // Drop empty price inputs
          Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
          window.location.search = params.toString();
        }, 400);
      });
    });
  }

  /* Reveal on scroll */
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.section .section-head, .section .product-grid, .section .category-tiles__grid, .promo-split__content, .gift-section__inner, .scent-families__grid', root).forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  function init(root) {
    initRotators(root);
    initSlideshows(root);
    initScrollers(root);
    initProduct(root);
    initRecommendations(root);
    initFacets(root);
    initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();
    init(document);
  });

  // Re-initialise sections when edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('.main-nav')) initMegaMenu(); });
})();
